import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreState, Language } from '@fitscovery/shared/store';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'fitscovery-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'partner-web';
  component: string;
  @Select(StoreState.language) language$: Observable<Language>;

  constructor(
    translate: TranslateService
  ) {
    translate.addLangs([ 'en', 'kr' ]);
    translate.setDefaultLang('en');
    this.language$.subscribe((language: Language) => {
      translate.use(language);
    });
  }

  onActivate(component: any): void {
    this.component = component;
  }
}
